import siteRole from './siteRole'
import permissionRole from './permissionRole'
import batch from './batch'
import customer from './customer'
import customerRank from './customerRank'
import upload from './upload'
import download from './download'
import log from './log'
import order from './order'
import orderDetail from './orderDetail'
import point from './point'
import pointSetting from './pointSetting'
import account from './account'
import product from './product'
import productDetail from './productDetail'
import stockAlert from './stockAlert'
import ecStock from './ecStock'
import masterColor from './masterColor'
import masterColorGroup from './masterColorGroup'
import masterSize from './masterSize'
import masterSizeGroup from './masterSizeGroup'
import orderQuantity from './orderQuantity'
import masterLogisticsCalendar from './masterLogisticsCalendar'
import mailTemplate from './mailTemplate'
import stockAdjustment from './stockAdjustment'
import stockMove from './stockMove'
import destination from './destination'
import pendingProduct from './pendingProduct'
import payment from './payment'
import paymentConvenience from './paymentConvenience'
import paymentCarrier from './paymentCarrier'
import paymentId from './paymentId'
import sales from './sales'
import salesDigital from './salesDigital'
import salesProductPhysical from './salesProductPhysical'
import salesProductDigital from './salesProductDigital'
import salesYell from './salesYell'

export default {
  siteRole: siteRole,
  permissionRole: permissionRole,
  batch: batch,
  customer: customer,
  customerRank: customerRank,
  upload: upload,
  download: download,
  log: log,
  order: order,
  orderDetail: orderDetail,
  point: point,
  pointSetting: pointSetting,
  account: account,
  product: product,
  productDetail: productDetail,
  stockAlert: stockAlert,
  ecStock: ecStock,
  masterColor: masterColor,
  masterColorGroup: masterColorGroup,
  masterSize: masterSize,
  masterSizeGroup: masterSizeGroup,
  orderQuantity: orderQuantity,
  masterLogisticsCalendar: masterLogisticsCalendar,
  mailTemplate: mailTemplate,
  stockAdjustment: stockAdjustment,
  stockMove: stockMove,
  destination: destination,
  pendingProduct: pendingProduct,
  payment: payment,
  paymentConvenience: paymentConvenience,
  paymentCarrier: paymentCarrier,
  paymentId: paymentId,
  sales: sales,
  salesDigital: salesDigital,
  salesProductPhysical: salesProductPhysical,
  salesProductDigital: salesProductDigital,
  salesYell: salesYell
}
